import { IconAlertOctagon } from '@/design-system';

/**
 * Aviso permanente de acesso de fornecedor — plano §6.5.
 *
 * POR QUE ELE NÃO PODE SER FECHADO
 * `PLATFORM_ADMIN` é o papel do FORNECEDOR (Riume) e pode entrar na organização
 * de qualquer cliente. Todo acesso nesse modo gera evento `VENDOR_ACCESS` na
 * trilha de auditoria do cliente, e o cliente é auditado por ANVISA e por
 * clientes dele.
 *
 * Duas consequências de projeto:
 *  1. o operador do fornecedor precisa saber, o tempo todo, que não está no seu
 *     próprio ambiente — um clique distraído vira registro no dossiê de outra
 *     empresa;
 *  2. numa inspeção, "o fornecedor tinha acesso e o sistema deixava isso
 *     invisível" é um achado. Aviso permanente e não dispensável é a resposta.
 *
 * ACESSIBILIDADE: `role="status"` com `aria-live="polite"` — é anunciado quando
 * a sessão elevada começa, sem interromper o que o usuário está fazendo. Cor,
 * ícone e texto juntos; a faixa não depende do amarelo para ser compreendida.
 */
export function VendorAccessBanner({ organizationName }: { readonly organizationName: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex flex-wrap items-center justify-center gap-2 border-b-2 border-warning bg-warning-subtle px-4 py-2 text-center text-sm text-warning-content"
    >
      <IconAlertOctagon size={16} aria-hidden="true" className="shrink-0" />
      <span>
        <strong className="font-bold uppercase tracking-wide">Acesso de fornecedor</strong>
        {' — '}
        você está operando
        {organizationName ? (
          <>
            {' '}
            no ambiente de <strong className="font-semibold">{organizationName}</strong>
          </>
        ) : (
          ' no ambiente de uma organização cliente'
        )}
        . Todas as suas ações são registradas na trilha de auditoria do cliente como acesso do
        fornecedor.
      </span>
    </div>
  );
}
